var map = {
	"./bed_basket.png": 4196,
	"./bed_plush.png": 1196,
	"./costume_bee.png": 939,
	"./costume_dino.png": 3883,
	"./hat_beanie.png": 412,
	"./hat_party.png": 4838,
	"./hat_trail_cap.png": 9631,
	"./neck_bandana.png": 1611,
	"./neck_bowtie.png": 8506,
	"./neck_classic.png": 6370,
	"./neck_sport.png": 8508,
	"./plant_bonsai.png": 2702,
	"./plant_fern.png": 3275,
	"./room_default.png": 1041,
	"./rug_round.png": 3759,
	"./rug_striped.png": 9378,
	"./tiwi_base.png": 5783,
	"./tiwi_base_blink.png": 2548,
	"./top_hoodie.png": 3630,
	"./top_raincoat.png": 8041,
	"./top_tee.png": 7782,
	"./toy_ball.png": 7034,
	"./toy_rope.png": 7329,
	"./wall_frame.png": 5320,
	"./wall_shelf.png": 7203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3059;